// import React from 'react';

// function StoryLibrary({ stories }) {
//   return (
//     <div className="library">
//       <h2>Your Stories</h2>
//       {stories.length === 0 ? (
//         <p>No stories published yet.</p>
//       ) : (
//         stories.map((story) => (
//           <div key={story.id} className="story-card">
//             <h3>{story.title}</h3>
//             <p><em>{story.date}</em></p>
//             <p>{story.content.slice(0, 200)}{story.content.length > 200 ? '...' : ''}</p>
//           </div>
//         ))
//       )}
//     </div>
//   );
// }

// export default StoryLibrary;
import React, { useState } from 'react';

function StoryLibrary({ stories, onDelete, onEdit }) {
  const [editingId, setEditingId] = useState(null);
  const [editTitle, setEditTitle] = useState('');
  const [editContent, setEditContent] = useState('');
  const [modalStoryId, setModalStoryId] = useState(null);


  const startEdit = (story) => {
    setEditingId(story._id);
    setEditTitle(story.title);
    setEditContent(story.content);
  };

  const submitEdit = () => {
    onEdit(editingId, { title: editTitle, content: editContent });
    setEditingId(null);
  };

  return (
    <div className="library">
      <h2>Yours</h2>
      {stories.length === 0 ? (
        <p>Nothing as yet.</p>
      ) : (
        stories.map((story) => (
          <div key={story._id} className="story-card">
            {editingId === story._id ? (
              <>
                <div className="editor">
                  <input value={editTitle} onChange={(e) => setEditTitle(e.target.value)} />
                  <textarea value={editContent} onChange={(e) => setEditContent(e.target.value)} />
                </div>
                <div className="button-group">
                  <button onClick={submitEdit}>Save</button>
                  <button onClick={() => setEditingId(null)}>Cancel</button>
                </div>
              </>
            ) : (
              <>
                <h3 onClick={() => setModalStoryId(story._id)} style={{ cursor: 'pointer' }}>{story.title}</h3>
                <p><em>{new Date(story.createdAt).toLocaleDateString()}</em></p>
                {story.imagePath && (
                  <img src={story.imagePath} alt={story.title} style={{ maxWidth: '300px' }} />
                )}
                <p>{story.content.length > 200 ? story.content.slice(0, 500) + '...' : story.content}</p>
                <div className="button-group">
                  <button onClick={() => startEdit(story)}>Edit</button>
                  <button onClick={() => onDelete(story._id)}>Delete</button>
                </div>
              </>


            )}

            {modalStoryId === story._id && (
              <div className="modal-overlay" onClick={() => setModalStoryId(null)}>
                <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                  <h2>{story.title}</h2>
                  <p><em>{new Date(story.createdAt).toLocaleDateString()}</em></p>
                  {story.imagePath && (
                    <img src={story.imagePath} alt={story.title} style={{ maxWidth: '600px' }} />
                  )}
                  <p className="story-text">{story.content}</p>
                  
                  <button onClick={() => setModalStoryId(null)}>Close</button>
                </div>
              </div>
            )}
          </div>
        ))


      )}
    </div>
  );
}

export default StoryLibrary;
